import React, { useContext } from 'react';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

import { AppState } from 'services/types';
import { makeSelectVirtualizedTableEditInitialValues } from 'services/virtualizedTable/selectors';
import { updateQueryString } from 'services/router/actions';
import { setItem } from 'services/virtualizedTable/actions';
import {
    VirtualizedTableItem,
    VirtualizedTableProps
} from 'services/virtualizedTable/types';

import unset from 'forms/mutators/unset';

import { VirtualizedTableContextProviderValue } from '../../types';
import VirtualizedTableItemForm from '../VirtualizedTableItemForm';
import VirtualizedTableContext from '../VirtualizedTableContext';
import { EDIT_MODAL_QUERY_STRING_PARAM } from '../../constants';

type OwnProps = VirtualizedTableProps;

interface ConnectedProps {
    initialValues: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableEditInitialValues>
    >;
}

type Props = OwnProps & ConnectedProps;

export const VirtualizedTableEditFormWrapperComponent = (
    props: Props
): React.ReactElement => {
    const dispatch = useDispatch();
    const { onItemUpdate, validateRow, setItemFormat } =
        useContext<VirtualizedTableContextProviderValue>(
            VirtualizedTableContext
        );
    const { initialValues } = props;

    const onSubmit = (item: VirtualizedTableItem): void => {
        let updatedItem = {
            ...initialValues,
            ...item
        };

        if (setItemFormat) updatedItem = setItemFormat(updatedItem);

        dispatch(setItem([updatedItem]));
        dispatch(
            updateQueryString({
                [EDIT_MODAL_QUERY_STRING_PARAM]: undefined
            })
        );
        if (onItemUpdate) onItemUpdate(item);
    };

    return (
        <FinalForm
            onSubmit={onSubmit}
            mutators={{
                unset,
                ...arrayMutators
            }}
            render={VirtualizedTableItemForm}
            subscription={{}}
            initialValues={initialValues}
            keepDirtyOnReinitialize
            validate={validateRow}
            // @ts-ignore
            isEditForm
        />
    );
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    initialValues: makeSelectVirtualizedTableEditInitialValues()
});

export default connect(mapStateToProps)(
    VirtualizedTableEditFormWrapperComponent
);
